import { createAppKit } from '@reown/appkit/react'
import { arbitrum, mainnet, polygon } from '@reown/appkit/networks'
import { QueryClient } from '@tanstack/react-query'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'

// 1. Get projectId from https://cloud.reown.com
const projectId = '95749b7f57022e6362d0cfc517d54d48'

// 2. Create a metadata object - optional
const metadata = {
  name: 'Falco P NFT',
  description: 'Falco P Sportswear Revolution NFT Collection',
  url: 'https://falcop.com', // origin must match your domain & subdomain
  icons: ['https://lavender-actual-hedgehog-248.mypinata.cloud/ipfs/bafkreihexz5vrnhhv6zhfp6bajlcq622qlkefe2346rwsd5czrvq3nfhka']
}

// 3. Set the networks
const networks = [mainnet, polygon, arbitrum]

// 4. Create Wagmi Adapter
const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: false // Set to true if used in server-side rendering environment
})

// 5. Create modal
export const appKit = createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata,
  features: {
    analytics: true // Optional - defaults to your Cloud configuration
  }
})

export const wagmiConfig = wagmiAdapter.wagmiConfig

// Create a client for React Query
export const queryClient = new QueryClient()
